import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {DeepResearchMessageType} from 'llm/deep-research/types';
import LLMMarkdownSection from 'llm/markdown/LLMMarkdownSection';
import {FONT_PROXIMA_14, FONT_WEIGHT_PROXIMA_REGULAR} from 'styles/FontConstants';
import {GRAY_LIGHT, GRAY_DARKER} from 'ui-library/Colors';

export interface ReportDeepResearchMessage {
  type: DeepResearchMessageType.SYSTEM_REPORT;
  content: string;
}

export function ReportMessage({message}: {message: ReportDeepResearchMessage}): JSX.Element {
  return (
    <div className={css(styles.systemReportLayout)} data-testid="system-report-message">
      <div className={css(styles.systemReportContainer)}>
        <div className={css(styles.systemReportContent)}>
          <LLMMarkdownSection markdown={message.content} />
        </div>
        {/* TODO (BNCH-124960): Add save button */}
        {/* <div className={css(styles.systemReportToolbar)}>
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            size={ButtonSize.MINI}
            onClick={noop}
            icon={<BenchlingIcon icon="save" />}
          />
        </div> */}
      </div>
      <div className={css(styles.systemReportFooter)} data-testid="system-report-footer">
        Reports are not auto saved during beta
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  // System report styles
  systemReportLayout: {
    display: 'flex',
    flexDirection: 'column',
  },

  systemReportContainer: {
    border: `1px solid ${GRAY_LIGHT}`,
    borderRadius: '4px',
    padding: '12px',
  },

  systemReportContent: {
    ...FONT_PROXIMA_14,
  },

  systemReportToolbar: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  systemReportFooter: {
    ...FONT_PROXIMA_14,
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
    color: GRAY_DARKER,
    fontSize: '12px',
    padding: '4px 12px',
    textAlign: 'center',
  },
});
